import { render, staticRenderFns } from "./registerDc.vue?vue&type=template&id=0f4b3233&scoped=true"
import script from "./registerDc.vue?vue&type=script&lang=js"
export * from "./registerDc.vue?vue&type=script&lang=js"
import style0 from "./registerDc.vue?vue&type=style&index=0&id=0f4b3233&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4b3233",
  null
  
)

export default component.exports